import { render, staticRenderFns } from "./NotPermission.vue?vue&type=template&id=7b43b034&"
import script from "./NotPermission.vue?vue&type=script&lang=js&"
export * from "./NotPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports